import * as React from 'react'
import StandardButton from '../buttons/standard-button'

import { Check, ExpandMore } from '@mui/icons-material'
import { Backdrop, Box, ButtonProps, Fade, Popper } from '@mui/material'
import { colors } from '../../constants/colors'
import { HBox, VBox } from '../../elements/basic-elements'
// import { EveryDonateButton } from '../every-donate-button'
import { ResultCardCtaProps } from './result-card-cta'
import ResultCardCtaSingle from './result-card-cta-single'

import {
  EVERY_DONATION_ACTION_SUFFIX,
  getActionCtaIconByCategory,
  getActionCtaLabelByCategory
} from '../../constants/actions'

import HelpIcon from '../../images/icons/help-icon'
import { authState } from '../../state/auth-state'
import { GiveLivelyDonateButton } from '../give-lively-donate-button'
// import { DemocracyEngineDonateButton } from '../democracy-engine-donate-button'

const ResultCardCtaMenu = ({ actionIsCompleted, data, onClickthrough }: ResultCardCtaProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const [anchorWidth, setAnchorWidth] = React.useState<number>(0)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!anchorEl) {
      setAnchorEl(event.currentTarget)
      setAnchorWidth(event.currentTarget.getBoundingClientRect().width) // capture width immediately
    } else {
      setAnchorEl(null)
    }
  }

  const normalizedContributions = (data.contributions || []).filter(
    Boolean
  ) as Queries.SanityActionContribution[]

  const baseDuration = 400
  const duration = baseDuration + 50 * normalizedContributions.length
  const open = Boolean(anchorEl)
  const id = open ? 'action-menu' : undefined


  return (
    <VBox height="100%">
      <StandardButton
        variant="contained"
        disableElevation
        color={actionIsCompleted ? 'success' : 'secondary'}
        sx={{ color: colors.WHITE, height: '100%' }}
        startIcon={
          actionIsCompleted ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              width={42}
              height={42}
              borderRadius={0.5}
              sx={{ background: theme => theme.palette.secondary.light }}
            >
              <Check sx={{ width: 24, height: 24 }} />{' '}
            </Box>
          ) : (
            <HelpIcon />
          )
        }
        endIcon={<ExpandMore sx={{ transform: 'rotate(180deg)' }} />}
        aria-describedby={id}
        onClick={handleClick}
      >
        <HBox justifyContent="center" flex={1}>
          Contribute
        </HBox>
      </StandardButton>
      <Backdrop
        open={open}
        onClick={() => setAnchorEl(null)}
        sx={{ zIndex: theme => theme.zIndex.modal }}
      />

      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement="top-start"
        sx={{ zIndex: theme => theme.zIndex.modal }}
        modifiers={[
          {
            name: 'offset',
            options: { offset: [0, 8] } // small vertical offset
          }
        ]}
        transition
      >
        {({ TransitionProps }) => {
          return (
            <Fade
              in={true}
              onEnter={TransitionProps.onEnter}
              onExit={TransitionProps.onExited}
              timeout={duration}
            >
              <VBox
                width="100%"
                gap={1}
                sx={{
                  minWidth: anchorWidth,
                  pointerEvents: open ? 'all' : 'none'
                }}
              >
                {normalizedContributions.map((contribution, i, a) => (
                  <Box
                    key={i}
                    sx={{
                      transform: TransitionProps.in ? 'translateY(0)' : 'translateY(16px)',
                      opacity: TransitionProps.in ? 1 : 0,
                      transition: TransitionProps.in
                        ? `transform 400ms cubic-bezier(0, 0, 0, 1) ${(a.length - i + 1) * 50}ms, opacity 200ms linear ${(a.length - i + 1) * 50}ms !important`
                        : 'transform 400ms cubic-bezier(0, 0, 0, 1) 100ms, opacity 50ms linear !important'
                    }}
                  >
                    {contribution.defaultDetails && (
                      <DefaultButton
                        details={contribution.defaultDetails}
                        onClick={onClickthrough}
                        disabled={!open}
                      />
                    )}
                    {/* {contribution.everyDetails && (
                      <EveryButton
                        details={contribution.everyDetails}
                        slug={data.slug.current}
                        disabled={!open}
                      />
                    )} */}
                    {contribution.giveLivelyDetails && (
                      <GiveLivelyButton
                        details={contribution.giveLivelyDetails}
                        slug={data.slug.current}
                        disabled={!open}
                      />
                    )}
                  </Box>
                ))}
              </VBox>
            </Fade>
          )
        }}
      </Popper>
    </VBox>
  )
}

const DefaultButton = ({
  details,
  ...buttonProps
}: { details: Queries.SanityActionContributionDefault } & ButtonProps) => (
  <ResultCardCtaSingle
    {...buttonProps}
    label={details.label || getActionCtaLabelByCategory(details?.type)}
    icon={getActionCtaIconByCategory(details?.type)}
    sx={{ width: '100%' }}
    onClick={e => {
      details.url && window.open(details.url, '_blank')
      buttonProps.onClick?.(e)
    }}
  />
)

// const EveryButton = ({
//   details,
//   slug,
//   ...buttonProps
// }: { details: Queries.SanityEveryDonation; slug: string } & ButtonProps) => {
//   const { actionsTaken } = authState()
//   return (
//     <EveryDonateButton
//       organization={details.organization}
//       action_id={slug}
//       isCompleted={
//         actionsTaken?.find(
//           ({ action_slug }) => action_slug == slug + EVERY_DONATION_ACTION_SUFFIX
//         ) != null
//       }
//       {...buttonProps}
//     />
//   )
// }

const GiveLivelyButton = ({
  details,
  slug,
  ...buttonProps
}: { details: Queries.SanityGiveLivelyDonation; slug: string } & ButtonProps) => {
  const { actionsTaken } = authState()
  return (
    <GiveLivelyDonateButton
      organization={details.organization}
      action_id={slug}
      isCompleted={
        actionsTaken?.find(
          ({ action_slug }) => action_slug == slug + EVERY_DONATION_ACTION_SUFFIX
        ) != null
      }
      {...buttonProps}
    />
  )
}

// const DemocracyEngineButton = ({
//   details,
//   slug,
//   ...buttonProps
// }: {
//   details: { organization?: Queries.SanityOrganization; recipientId?: string }
//   slug: string
// } & ButtonProps) => {
//   const organization = details?.organization
//   const recipientId = details?.recipientId

//   return (
//     <DemocracyEngineDonateButton
//       organization={organization}
//       recipientId={recipientId}
//       action_id={slug}
//       disabled={buttonProps.disabled || !recipientId}
//       {...buttonProps}
//     />
//   )
// }

export default ResultCardCtaMenu
